
export const MEDREC_MEDICATION_STATUS = {
  VERIFIED: 'VERIFIED',
  MODIFIED: 'MODIFIED',
  ADDED: 'ADDED',
  DISCONTINUED: 'DISCONTINUED',
  WARNING: 'WARNING'
}
